import { useEffect, useState } from 'react';
import { listTruckServiceItems } from '../../truck-service/truck-service.api';
import { earliestDayBasedDueDate } from '../policies/service-due-date';

/** The truck's plan is bounded by the item catalogue, so one page of the largest size is all of it. */
const ALL_PLAN_ITEMS = { page: 1, pageSize: 100, q: undefined, sort: 'name', order: 'asc', source: undefined } as const;

/** When the truck's soonest time-based service falls due (`YYYY-MM-DD`), for the window search to start from; null while loading or when none has a date. */
export function useServiceDueDate(truckId: string): string | null {
  const [dueDate, setDueDate] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    listTruckServiceItems(truckId, ALL_PLAN_ITEMS)
      .then((page) => !cancelled && setDueDate(earliestDayBasedDueDate(page.items)))
      .catch(() => !cancelled && setDueDate(null));
    return () => {
      cancelled = true;
    };
  }, [truckId]);

  return dueDate;
}
